var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 60,
    viewBox: "0 0 88 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 60,
    width: 8,
    height: 60,
    transform: "rotate(-180 8 60)",
    fill: "#E63946"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    width: 8,
    height: 80,
    transform: "rotate(90 88 0)",
    fill: "#E63946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup07);
export default __webpack_public_path__ + "static/media/Group 07.034bd4009e5712ff7adc331e31d9652e.svg";
export { ForwardRef as ReactComponent };